<script>
import CorporationDataV3 from 'vcomponents/sellsyadmin/CorporationData_v3.vue';
import AnnotationsTab from 'vcomponents/pages/overview/AnnotationsTab.vue';
import DocumentEmail from 'vcomponents/documents/DocumentEmail.vue';
import DocumentSendEmail from 'vcomponents/documents/DocumentSendEmail.vue';
import EmailMixins from 'mixins/EmailMixins';
import Store from 'stores/overview/document/store';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('documentOverview');
import KpiList from 'vcomponents/utilities/KpiList.vue';
import DocumentTagWrapper from 'vcomponents/documents/DocumentTagWrapper/DocumentTagWrapper.vue';
import DocumentStatusEditInPlace from 'vcomponents/documents/DocumentStatusEditInPlace/DocumentStatusEditInPlace.vue';

export default {
    components: {
        CorporationDataV3,
        AnnotationsTab,
        DocumentEmail,
        DocumentSendEmail,
        KpiList,
        DocumentTagWrapper,
        DocumentStatusEditInPlace,
    },
    mixins: [EmailMixins],
    props: {
        ovtype: {
            type: String,
            default: '',
            required: false,
        },
        fileid: {
            type: String,
            default: '',
        },
        linkedid: {
            type: String,
            default: '',
        },
        linkedtype: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showTimeline:
                $('#' + this.ovtype + 'VerticalTab')
                    .find('.tab-v-menu li.current a')
                    .attr('id') === 'activity',
        };
    },
    computed: {
        ...mapState(['fileId', 'docFile']),
    },
    mounted() {
        EventBus.on('email:sendDocument', async () => {
            this.$store.dispatch('documentOverview/getDocFile');
            this.checkEmailProvider(
                {
                    template: {
                        type: 'proposal',
                        contact: {
                            id: parseInt(this.linkedid),
                            type: 'proposal',
                        },
                        related: [
                            {
                                id: parseInt(this.linkedid),
                                type: 'proposal',
                            },
                        ],
                    },
                    related: [
                        {
                            id: this.linkedid,
                            type: 'proposal',
                        },
                    ],
                },
                { checkPrefill: true },
            );
        });
    },
    created() {
        this.$store.registerModule('documentOverview', Store);
        this.$store.commit('documentOverview/init', {
            fileId: this.fileid,
        });
    },
    destroyed() {
        EventBus.off('email:sendDocument');
    },
    methods: {
        refreshTimeline(status) {
            this.showTimeline = status;
            window.EventBus.emit('refreshTimeline');
        },
    },
};
</script>
